<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Utilisateurs :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchUsersList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.UsersHeaders"
                        :items="$store.state.usersListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchUsersList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            +
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireUsers></FormulaireUsers>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.usersEditedItem.NOM != '' && 
                                                    $store.state.usersEditedItem.PRENOM != '' && 
                                                    $store.state.usersEditedItem.EMAIL != '' "
                                                color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer cet utilisateur ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.usersEditedItem.NOM }} {{ $store.state.usersEditedItem.EMAIL }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.ADMIN="{ item }">
                            <v-simple-checkbox
                                v-model="item.ADMIN"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
	import FormulaireUsers from './FormulaireUsers.vue';

	export default {
    name: "GestionUsers",
    components: { FormulaireUsers },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            formHasErrors: false,
            defaultItem: {
                REFERENCE: '',
                SYSTEM_ID: '',
                DESC_NL: '',
                DESC_FR: '',
                TYPE: '',
                QUANTITY: 0,
                DC_CURRENT: 0,
                DC_CABLE: 0,
                FAMILY: '',
                ACCESSORIES_PB: '',
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouvel utilisateur" : "Modifier l'utilisateur";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogCopy(val) {
            val || this.closeCopy();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createUsersListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        editItem(item) {
            this.editedIndex = this.$store.state.usersListBool.indexOf(item);
            this.$store.state.usersEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.usersListBool.indexOf(item);
            this.$store.state.usersEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.usersListBool.indexOf(item);
            this.$store.state.usersEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.usersListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteUsers.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.usersEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.usersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.usersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadUsersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.usersList = response.data;
                        this.createUsersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.usersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.usersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.usersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.usersListBool[this.editedIndex], this.$store.state.usersEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editUser.php";
            }
            else {
                this.$store.state.usersListBool.push(this.$store.state.usersEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addUser.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.usersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.usersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.usersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadUsersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.usersList = response.data;
                        this.createUsersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addUser.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.usersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.usersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.usersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadUsersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.usersList = response.data;
                        this.createUsersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
    },
}
</script>
